import React from 'react';

import {
  Button,
  Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, FormControlLabel, RadioGroup, Radio,
} from '@mui/material';

import { withStyles } from '@mui/styles';
import ComponentWrapper from '../../../common/ComponentWrapper';

const styles = {
  valDialog: {
    width: '297px',
  },
  valDialogTitle: {
    textAlign: 'center',
    fontSize: 16,
    lineHeight: '22px',
  },
  cancelBtn: {
    fontSize: 16,
    color: '#878787',
    textTransform: 'none',
    background: 'transparent',
    padding: '10px 30px',
    '&:hover': {
      color: '#222029',
    },
  },
  acceptBtn: {
    fontSize: 16,
    color: '#222029',
    fontWeight: '600',
    textTransform: 'none',
    padding: '10px 30px',
    opacity: '0.9',
    '&:hover': {
      opacity: '1.0',
      color: '#222029',
    },
  },
};

const StyledRadio = withStyles({
  root: {
    '&$checked': {
      color: '#878787',
    },
  },
  checked: {},
})(Radio);

const StyledLabel = withStyles({
  label: {
    fontSize: 12,
    lineHeight: '16px',
  },
})(FormControlLabel);

class ValueApplyDialog extends ComponentWrapper {
  state = {
    strategy: 0
  }

  doValuePropagation = (rstId) => {
    const { valExpSetProcessing, name, valDefSetProcessing } = this.props;
    const { strategy } = this.state;
    if (name==='Applying default to predicates') {
      valDefSetProcessing(
        true,
        () => {
          this.postWithData({
            url: "/rest/do_def_val_prop",
            data: {
              rstId,
              strategy,
            },
            cb: () => {
              valDefSetProcessing(false);
            }
          });
        }
      );
    } else if (name==='Applying expression to predicates') {
      valExpSetProcessing(
        true,
        () => {
          this.postWithData({
            url: "/rest/do_val_exp_prop",
            data: {
              rstId,
              strategy,
            },
            cb: () => {
              valExpSetProcessing(false);
            }
          });
        }
      );
    }
  };

  render() {
    const { classes, rst, valDialogOpen, onClose, name} = this.props;

    return (
      <Dialog
      open={valDialogOpen}
      onClose={onClose}
      aria-labelledby="val-dialog-title"
      >
        <DialogTitle className={classes.valDialogTitle} id="val-dialog-title">
          {name}
        </DialogTitle>
          <DialogContent className={classes.valDialog}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="val-apply-value"
                name="val-strategy"
                value={this.state.strategy}
                onChange={(event) => this.setState({ strategy: parseInt(event.target.value, 10) }) }
              >
                <StyledLabel value={0} control={<StyledRadio />} label="All nodes" />
                <StyledLabel value={1} control={<StyledRadio />} label="Nodes with empty triples" />
                <StyledLabel value={2} control={<StyledRadio />} label="Nodes with not empty triples" />
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', backgroundColor: '#FBFBFB' }}>
            <Button
              className={classes.cancelBtn}
              onClick={onClose}
            >
              Cancel
          </Button>
          <Button
            className={classes.acceptBtn}
            onClick={() => this.doValuePropagation(rst.id)}
            autoFocus
          >
            Agree
        </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(ValueApplyDialog);